
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-sage-50 py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid md:grid-cols-3 gap-8 sm:gap-12 mb-10 sm:mb-12">
          <div>
            <h4 className="text-xl sm:text-2xl font-display font-semibold text-gray-900 mb-3 sm:mb-4">Alex Rivera</h4>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              NYC-based UGC creator crafting authentic content that connects brands with their audience.
            </p>
          </div>

          <div>
            <h4 className="text-xs sm:text-sm font-display font-semibold text-gray-900 mb-3 sm:mb-4 uppercase tracking-wider">Quick Links</h4>
            <div className="space-y-2.5 sm:space-y-3">
              {[
                { label: 'About', id: 'about' },
                { label: 'Collaborations', id: 'nyc-collabs' },
                { label: 'Testimonials', id: 'testimonials' },
                { label: 'Contact', id: 'contact' },
              ].map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="block text-xs sm:text-sm text-gray-600 hover:text-sage-500 transition-colors cursor-pointer"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs sm:text-sm font-display font-semibold text-gray-900 mb-3 sm:mb-4 uppercase tracking-wider">Contact</h4>
            <div className="space-y-2.5 sm:space-y-3 text-xs sm:text-sm text-gray-600">
              <p>(212) 555-1234</p>
              <p>alex@example.com</p>
              <div className="pt-2">
                <p className="text-xs font-semibold text-gray-900 mb-1">Location</p>
                <p>New York City, NY</p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-6 sm:pt-8 border-t border-sage-200">
          <div className="flex flex-col md:flex-row items-center justify-between gap-5 sm:gap-6">
            <div className="flex items-center gap-4 sm:gap-5">
              {[
                { label: 'Instagram', url: 'https://instagram.com', icon: 'ri-instagram-line' },
                { label: 'TikTok', url: 'https://tiktok.com', icon: 'ri-tiktok-line' },
                { label: 'LinkedIn', url: 'https://linkedin.com', icon: 'ri-linkedin-line' },
                { label: 'YouTube', url: 'https://youtube.com', icon: 'ri-youtube-line' },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-9 h-9 flex items-center justify-center text-gray-500 hover:text-sage-500 hover:bg-sage-50 rounded-full transition-all cursor-pointer"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-base sm:text-lg`}></i>
                </a>
              ))}
            </div>

            <p className="text-xs sm:text-sm text-gray-500">
              &copy; 2025 Alex Rivera. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
